<template>
  <div class="dashiji-item-container">
    <custom-router-link :item="info" class="dashiji-link" :to="{name: 'DashijiDetails', params: {id: info.id}}" target="_blank">
      {{info.publishTime && info.publishTime.split(" ")[0]}}，{{info.name}}
    </custom-router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  props: {
    info: {
      type: Object,
      default: () => { }
    },
  },
  components: {

  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style lang="less" scoped>
.dashiji-item-container {
  width: 100%;
  .dashiji-link {
    display: flex;
    width: 100%;
    height: 100%;
    color: #333;
    font-size: 18px;
    line-height: 26px;
    padding-left: 20px;
    position: relative;
    &::before {
      position: absolute;
      width: 6px;
      height: 6px;
      border-radius: 100%;
      background: #333;
      content: "";
      display: block;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
    }
    .news-image {
      width: 268px;
      height: 100%;
      .el-image {
        width: 100%;
        height: 100%;
      }
    }
    .news-details {
      flex: 1;
      width: calc(100% - 16px - 268px);
      padding: 16px;
      .publish-time {
        color: #6c757d;
        font-size: 16px;
        margin: 8px 0;
      }
      .news-title {
        font-size: 20px;
        font-weight: 600;
        line-height: 32px;
        margin: 10px 0;
        color: #333;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .news-summary {
        font-size: 14px;
        color: #6c757d;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 4;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .dashiji-item-container {
    .dashiji-link {
      font-size: 14px;
      line-height: 22px;
      padding-left: 14px;
      &::before {
        width: 5px;
        height: 5px;
      }
    }
  }
}
</style>